import { Box } from '@mui/material'
import { t } from 'i18next'
import { useAppSelector } from '../../store/redux/hooks'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { EditNotifications } from '@mui/icons-material'
import MasonryTileTitle from '../../components/Masonry/MasonryTileTitle'
import { StyledScheduleStickyTitle } from '../../styles/ScheduleViewStyles'
import MasonryTile from '../../components/Masonry/MasonryTile'
import MissingHoursNotificationDialog from '../../components/Popup/AdministratorView/MissingHoursNotificationDialog'
import AdministrativeNotificationDialog from '../../components/Popup/AdministratorView/AdministrativeNotificationDialog'

const MasonryTileNotifications = () => {
  useAppSelector(state => getCurrentUser(state))

  return (
    <MasonryTile>
      <StyledScheduleStickyTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <MasonryTileTitle
            title={t('page.adminsPage.generalSettings.menageNotifications')}
            icon={EditNotifications}
            sx={{ gap: 2 }}
          />
        </Box>
      </StyledScheduleStickyTitle>
      <MissingHoursNotificationDialog />
      <AdministrativeNotificationDialog />
    </MasonryTile>
  )
}

export default MasonryTileNotifications
